
export { GGUSection } from "/codebuild/output/src187247037/src/packages/shared-components/src/campaign/GGUSection.tsx"